export default "__VITE_ASSET__9d676eab__"